/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidOptionModel } from '../../models/medical-aid-option-model';

export interface MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Params {
  medicalAidId: string;
  medicalAidSchemeId: string;
  medicalAidOptionId: string;
}

export function medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidOptionModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet.PATH, 'get');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.path('medicalAidSchemeId', params.medicalAidSchemeId, {});
    rb.path('medicalAidOptionId', params.medicalAidOptionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<MedicalAidOptionModel>;
    })
  );
}

medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet.PATH = '/MedicalAid/MedicalAidOptionGet/{medicalAidId}/{medicalAidSchemeId}/{medicalAidOptionId}';
